export default "__VITE_ASSET__BaZEB0rX__"